import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoundaboutRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"roundabout_right"}/>
}
